import { PATH_PAGE } from '../../routes/paths';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import WorkOutlineRounded from '@mui/icons-material/WorkOutlineRounded';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import QueryStatsRounded from '@mui/icons-material/QueryStatsRounded';
import EmojiEventsOutlined from '@mui/icons-material/EmojiEventsOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import ChatBubbleOutlineRounded from '@mui/icons-material/ChatBubbleOutlineRounded';

// ----------------------------------------------------------------------

export type NavItem = {
  title: string;
  path: string;
  icon: typeof HomeOutlined;
  section: 'Explore' | 'Company';
};

/** The links in the header and the mobile drawer. */
export const NAV_ITEMS: NavItem[] = [
  { title: 'Home', path: PATH_PAGE.root, icon: HomeOutlined, section: 'Explore' },
  { title: 'Find jobs', path: PATH_PAGE.jobs, icon: WorkOutlineRounded, section: 'Explore' },
  { title: 'Companies', path: PATH_PAGE.companies, icon: BusinessOutlined, section: 'Explore' },
  {
    title: 'Salary insights',
    path: PATH_PAGE.salaryInsights,
    icon: QueryStatsRounded,
    section: 'Explore',
  },
  { title: 'Win a job', path: PATH_PAGE.contest, icon: EmojiEventsOutlined, section: 'Explore' },
  { title: 'About', path: PATH_PAGE.about, icon: InfoOutlined, section: 'Company' },
  { title: 'Contact', path: PATH_PAGE.contact, icon: ChatBubbleOutlineRounded, section: 'Company' },
];
